import React, { Component } from 'react'
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";


export class Editbuilders extends Component {
  render() {
    return (
      <div>Editbuilders</div>
    )
  }
}

export default Editbuilders


export function Editbuildersc(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const param = useParams();
  return <Editbuilders param={param} navigate={navigate}></Editbuilders>;
}
